import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { TemplateEditorModule } from '@app/main/template-editor/template-editor.module';
import { OrgTreeComponent } from './org-tree.component';
import { OrgTreeRoutingModule } from './org-tree-routing.module';
import { OrgTreeNodeComponent } from './org-tree-node/org-tree-node.component';
import { OrgHeaderComponent } from './org-header/org-header.component';
import { OrgModifyComponent } from './org-modify/org-modify.component';
import { OrgSettingsComponent } from './org-settings/org-settings.component';
import { OrgBreadcrumbComponent } from './org-breadcrumb/org-breadcrumb.component';
import { OrgDrawerComponent } from './org-drawer/org-drawer.component';
import { OrgReportingComponent } from './org-reporting/org-reporting.component';
import { OrgDrawerReportsComponent } from './org-drawer/org-drawer-reports/org-drawer-reports.component';
import { OrgMassUnpublishComponent } from './org-mass-unpublish/org-mass-unpublish.component';
import { OrgCommunicationSettingsComponent } from './org-communication-settings/org-communication-settings.component';
import { TimelineComponent } from './org-communication-settings/timeline/timeline.component';
import { MailRecipientListComponent } from './org-communication-settings/mail-recipient-list/mail-recipient-list.component';
import { CcRecipientsDialogComponent } from './org-communication-settings/cc-recipients-dialog/cc-recipients-dialog.component';
import { RecipientItemComponent } from './org-communication-settings/recipient-item/recipient-item.component';

@NgModule({
    declarations: [
        OrgTreeComponent,
        OrgTreeNodeComponent,
        OrgHeaderComponent,
        OrgModifyComponent,
        OrgSettingsComponent,
        OrgBreadcrumbComponent,
        OrgDrawerComponent,
        OrgReportingComponent,
        OrgDrawerReportsComponent,
        OrgMassUnpublishComponent,
        OrgCommunicationSettingsComponent,
        TimelineComponent,
        MailRecipientListComponent,
        CcRecipientsDialogComponent,
        RecipientItemComponent
    ],
    imports: [CommonModule, SharedModule, OrgTreeRoutingModule, TemplateEditorModule]
})
export class OrgTreeModule {}
